import { module } from 'modujs';
import { html } from '../utils/environment';
import * as focusTrap from 'focus-trap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close()
            }
        }

        document.addEventListener('keyup', this.closeBind)
        this.trap = focusTrap.createFocusTrap(this.el);
    }

    toggle() {
        if(html.classList.contains('has-search-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        html.classList.add('has-search-open')

        this.call('closeMenu', null, 'Menu');
        this.call('closeOverlay', null, 'CategorieButton');

        setTimeout(() => {
            this.$('input')[0].focus()
            this.trap?.activate();
        }, 300);
    }

    close() {
        html.classList.remove('has-search-open')
        this.trap?.deactivate();

        setTimeout(() => {
            this.$('input')[0].value = ''
        }, 300);
    }

    destroy() {
        super.destroy()

        document.removeEventListener('keyup', this.closeBind)
    }
}
